import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import config from '../config/env.json';
import './index.css';
import './i18n';

// Direct-load guard: if the SPA is loaded as a top-level document instead of
// inside the embed iframe, redirect to the main app. Caddy already does this
// at the edge via Sec-Fetch-Dest, but older browsers don't send that header.
if (typeof window !== 'undefined' && window.self === window.top) {
  const target =
    (config as { MAIN_APP_URL?: string }).MAIN_APP_URL ||
    'https://app.wunderguide.com';
  window.location.replace(
    target + window.location.pathname + window.location.search,
  );
} else {
  // Side-effect import — instantiates auth core + http clients before any
  // component renders. Only do this when actually embedded.
  import('./client').then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
}
